<template>
    <div class="cover-section my-12 py-12">
        <div class="text-h4 text-center font-weight-bold mb-6" v-html="$t('home.trust.title')">
          
          </div>
          <div class="d-flex my-9 flex-column flex-sm-row">
            <div class="d-flex my-9 overflow-hidden --half-icons">

              <v-img height="30" contain src="@/assets/companies/band-news.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/band.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/cnn.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/df.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/eletromidia.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/elle.svg"></v-img>
            </div>
            <div class="d-flex my-9 overflow-hidden --half-icons">
              
              <v-img height="30" contain src="@/assets/companies/ft.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/gazeta.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/massa-fm.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/record.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/info-money.svg"></v-img>
            </div>
          </div>
          <div class="d-flex my-9 flex-column flex-sm-row">
            <div class="d-flex my-9 overflow-hidden --half-icons">
              <v-img height="30" contain src="@/assets/companies/jcdecaux.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/jovem-pan.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/metropolitana.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/nacional-pe.svg"></v-img>
              <v-img width="130" height="30" contain src="@/assets/companies/neooh.svg"></v-img>
            </div>
            <div class="d-flex my-9 overflow-hidden --half-icons">  
              <v-img height="30" contain src="@/assets/companies/vogue.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/globo.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/difusora.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/trans.svg"></v-img>
              <v-img height="30"  contain src="@/assets/companies/uol.svg"></v-img>
            </div>
          </div>
          
          <div class="d-flex my-9 flex-column flex-sm-row">
            <div class="d-flex my-9 overflow-hidden --half-icons"> 
              <v-img height="30" contain src="@/assets/companies/cbn.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/abril.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/estadao.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/g1.svg"></v-img>
            </div>
            <div class="d-flex my-9 overflow-hidden --half-icons"> 
              <v-img height="30" contain src="@/assets/companies/svm.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/grupo-semana.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/itabus.svg"></v-img>
              <v-img height="30" contain src="@/assets/companies/mtv.svg"></v-img>
            </div>
            
          </div>
        </div>
      </template>
<script>
export default {
    name: "CoverSection"
}
</script>
<style>
.--half-icons{
  flex: 1 1 50%;
}
</style>